
/*
 * Show Today's Hours
 */
const mmaHoursText = document.querySelector("#mmaHoursText");
const mmaHours = document.querySelector("#mmaHours");

if (mmaHours && mmaHoursText) {
  console.log('ok');
  const d = new Date();
  let day = d.getDay(); //0-6
  let theHours = '';
  switch(day)
					{
					   case 0 : theHours = '<!--Sunday-->' + mmaHours.dataset.hoursSun; break;
					   case 1 : theHours = '<!--Monday-->' + mmaHours.dataset.hoursMon; break;
					   case 2 : theHours = '<!--Tuesday-->' + mmaHours.dataset.hoursTue; break;
					   case 3 : theHours = '<!--Wednesday-->' + mmaHours.dataset.hoursWed; break;
					   case 4 : theHours = '<!--Thursday-->' + mmaHours.dataset.hoursThu; break;
					   case 5 : theHours = '<!--Friday-->'+ mmaHours.dataset.hoursFri; break;
					   case 6 : theHours = '<!--Saturday-->'+ mmaHours.dataset.hoursSat; break;
					}
  
  if (theHours) {
    mmaHours.innerHTML = theHours;
    mmaHoursText.firstChild.classList.remove("d-none");
  }
}



/*
 * Create parallax effect for headlines with class .mma-parallax-text
 *
 * Applies transform: translate to the element based on where it is vertically in the viewport
 * 
 * Reference: //https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
 */

function mmaIsElementInViewport (el) {
  var rect = el.getBoundingClientRect();
  var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  return (
      // Top is above bottom of viewport. Bottom is lower than the top of the viewport.
      (rect.top <= windowHeight || rect.bottom <= windowHeight ) && 
      (rect.top + rect.height) >= 0 
  );
}

const parallaxTargets = document.querySelectorAll('.mma-parallax-text');
const scrollMaxTranslate = 4; // Max rem elements can move up or down
const scrollLessModifier = .33;

function mmaScrollFunction() {
  for (let i = 0; i < parallaxTargets.length; ++i) {
    var visible = mmaIsElementInViewport(parallaxTargets[i]);
    if (visible) {
      let el = parallaxTargets[i];
      let pos = el.getBoundingClientRect().bottom;
      var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
      let ratio = (pos - windowHeight) / windowHeight;
      let trans = ratio * scrollMaxTranslate;
      if (el.classList.contains('less')) trans = trans * scrollLessModifier;
      if (el.classList.contains('more')) trans = trans + (trans * scrollLessModifier);
      if (el.classList.contains('reversed')) trans = trans * -1;
      var direction = (el.classList.contains('horiz')) ? 'X' : 'Y'; // flip direciton
      //console.log('trans'+direction+' '+trans+'rem');
      el.style.transform = 'translate'+direction+'('+trans+'rem)';

    } else {
      // Do nothing
    }
  }
}
if (window.addEventListener) {
  window.addEventListener('DOMContentLoaded', mmaScrollFunction);
  window.addEventListener('load', mmaScrollFunction);
  window.addEventListener('scroll', mmaScrollFunction);
  window.addEventListener('resize', mmaScrollFunction);
} 


/*
function forceScrollInit() {
  // force above-the-fold animations to run on screen load
  window.scroll(); 
  window.scrollTo();
}
if (window.addEventListener) {
  window.addEventListener('load', forceScrollInit);
  window.addEventListener('DOMContentLoaded', forceScrollInit);
}
  /*
/*
window.onbeforeunload = function () {
  window.scroll(); // force above the fold animations to run on screen load
  window.scrollTo();
  console.log('Load and Scroll: onbeforeunload');

}*/

/*
 * Toggle Detail Accordions on anchor navigation
 *
 * Reference: https://stackoverflow.com/questions/37033406/automatically-open-details-element-on-id-call
 */

function openTarget() {
  const hash = location.hash.substring(1);
  if (hash) {
      //console.log('Hash: ' + hash);
      const target = document.getElementById(hash);
      if (target) {
          //console.log('Target: ' + target.innerHTML);
          var details = '';
          if (target.tagName.toLowerCase() === 'details') {
            details = target;
          } else {
            details = target.querySelector("details");
          }
          if (details && details.tagName.toLowerCase() === 'details') {
            // opens the target if it is a details element or the target's first child detail element
            details.open = true;            
            //console.log('Details state: ' + details.open);
          }
      }
  }
}
openTarget(); // onload
window.addEventListener('hashchange', openTarget);

/*
 * Toggle Search
 */
var search_button = document.getElementById('mmaSearchLink');
var search_bar = document.getElementById('mmaSearchBar');
if (search_button && search_bar) {
  search_button.onclick = function(e) {
    e.preventDefault();
    this.classList.toggle("toggled");
    search_bar.classList.toggle("toggled");
    document.getElementById("s-1").focus();
  }
}

/*
 * Toggle Footer Accordions
 */
const footer_accordions = document.querySelectorAll(".widget_nav_menu:not(:has(.menu-social-container)) > .widgettitle");
  // Selecting the title instead of the parent container to allow for child links to be clickable.
for (let i = 0; i < footer_accordions.length; i++) {
  
  footer_accordions[i].onclick = function(e) {
      
    e.preventDefault();
    //console.log('click');
    this.parentNode.classList.toggle("toggled");
    
    //console.log('click');
  }

 
}


/*
 * Modal windows for team/staff (DISABLED!)
 * 
 * Reference: https://www.w3schools.com/howto/howto_css_modals.asp
 *            https://www.w3schools.com/tags/tryit.asp?filename=tryhtml5_global_data
 */

/*
const modal_btns = document.getElementsByClassName("team-modal-btn");

for (let i = 0; i < modal_btns.length; i++) {
  var this_modal_btn = modal_btns[i];
  var this_modal_id = this_modal_btn.getAttribute("data-modal-target");
  if (this_modal_id) {
      this_modal_btn.onclick = function(e) {
        e.preventDefault();
        var this_modal_id = this.getAttribute("data-modal-target");


        var this_modal = document.getElementById(this_modal_id);
        if (this_modal) {
          var span = this_modal.getElementsByClassName("team-modal-close")[0];
          if (span) { 
              span.onclick = function() {
                this_modal.style.display = "none";
              }
          }
          this_modal.style.display = "block";
        }
        
      }

    
  } //if (this_modal_id) {

} //for (let i = 0; i < modal_btns.length; i++) {

window.onclick = function(event) {
  // When the user clicks anywhere outside of the modals, close it
  var modals = document.getElementsByClassName("team-modal");
  
  for (let i = 0; i < modals.length; i++) {
    if (event.target == modals[i]) {
      modals[i].style.display = "none";
    }
  }

}

var modals = document.getElementsByClassName("team-modal");

for (let i = 0; i < modals.length; i++) {
  
  
  document.body.appendChild(modals[0]); // always append [0] since it is removed from the array each time (what was [1] becomes [0])
  
}
*/




/*
 * Swiper
 * 
 * Reference: https://swiperjs.com/
 *            https://swiperjs.com/demos
 *            https://wordpress.org/plugins/wp-swiper/
 *            https://digitalapps.com/wordpress-plugins/wp-swiper/
 *            https://github.com/nolimits4web/swiper/
 */

var swiper = new Swiper(".mySwiper", {
  slidesPerView: 2,
  lazyPreloadPrevNext: 1,
  spaceBetween: 16,
  centeredSlides: false,
  lazy: true,
  keyboard: {
    enabled: true,
  },
  mousewheel: false,
  grabCursor: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    576: {
      slidesPerView: 3,
      lazyPreloadPrevNext: 2,
    },
    768: {
      slidesPerView: 4,
      lazyPreloadPrevNext: 3,
    },
    1200: {
      slidesPerView: 5,
      lazyPreloadPrevNext: 4,
    },
    1400: {
      slidesPerView: 6,
      lazyPreloadPrevNext: 5,
    },
  },
});




/*
 * Add back in click events for dropdown menus
 * Either bootstrap or understrap is preventing the default event.... so add it back.
 * 
 * Reference: https://stackoverflow.com/questions/29223502/how-to-get-href-of-anchor-when-the-event-target-is-htmlimageelement
 */
document.querySelectorAll(".dropdown-toggle").forEach(function(dropdown) { 
  dropdown.addEventListener("click", function(event) {
    event.preventDefault();                               // Don't do whatever bootstrap or understrap is trying to do
    const anchor = event.target.closest("a");             // Find closest Anchor (or self)
    if (!anchor) return;                                  // Not found. Exit here.
    anchor.setAttribute("aria-expanded", false);          // Keep menu closed if user uses back navigation in browser
    const next = anchor.parentElement.getElementsByClassName("dropdown-menu")[0];                    // Select dropdown ul
    next.classList.remove("show");                        // Keep menu closed if user uses back navigation in browser
    window.location.assign(anchor.getAttribute('href'));  // Navigate as expected
  });
});
  


/*
 * Animate Accordions
 * https://codepen.io/chriscoyier/pen/XWNqxyY
 * https://css-tricks.com/how-to-animate-the-details-element/
 */
class Accordion {
  constructor(el) {
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector('summary');
    // Store the <div class="content"> element
    this.content = el.querySelector('.details-inner-container');
    this.minHeight = 10;

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open();
    // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;
    
    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
   
    // Calculate the height of the summary
    var endHeight = `${this.summary.offsetHeight}`;
    if (endHeight < this.minHeight) endHeight = this.minHeight;
    endHeight = endHeight + 'px';
    
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    
    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 200, 
      easing: 'linear'
    });
    
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    var startHeight = `${this.el.offsetHeight}`;
    if (startHeight < this.minHeight) startHeight = this.minHeight;
    startHeight = startHeight + 'px';
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    
    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 200,
      easing: 'linear'
    });
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('details:has(.details-inner-container)').forEach((el) => {
  new Accordion(el);
});


/**************************************
 * 
 * Force remove ongoing events from upcoming events list
 * 
 */

document.querySelectorAll(".mec-event-list-classic article:has(.mec-ongoing-normal-label)").forEach(function(e) { 
  e.remove();
});
